<template >
  <div class="BackgroundRelief">
  </div>
</template>

<script>
import * as THREE from 'three'
import { TweenLite, Power2 } from 'gsap' // Juste pour le ticker, vire le si tu a un autre ticker
export default {
  name: 'BackgroundRelief',

  data () {
    return {
      viewport: {}, // camera vars
      forceUpdate: false, // forceUpdate
      x: 0, // mouse vars
      y: 0, // mouse vars
      easeX: 1000, // mouse vars
      easeY: 1000 // mouse vars
    }
  },

  mounted () {
    this._mouseMoveHandler = this.mouseMoveHandler.bind(this)
    this._resize = this.resize.bind(this)
    this._tick = this.tick.bind(this)
    TweenLite.ticker.addEventListener('tick', this._tick)
    window.addEventListener('mousemove', this._mouseMoveHandler)
    window.addEventListener('resize', this._resize)
    window.addEventListener('orientationchange', this._resize)
    //
    this.initThree()
    this.initCamera()
    this.initLight()
    this.initFloor()
    this.$nextTick(this._resize)
    this.animateIn()
  },

  beforeDestroy () {
    window.removeEventListener('mousemove', this._mouseMoveHandler)
    TweenLite.ticker.removeEventListener('tick', this._tick)
    window.removeEventListener('resize', this._resize)
    window.removeEventListener('orientationchange', this._resize)
    this.object3d.children.forEach(mesh => {
      TweenLite.killTweensOf(mesh)
    })
  },

  methods: {
    animateIn () {
      this.object3d.children.forEach((mesh, i) => {
        const delay = 0.5 + (this.object3d.children.length * 0.2 - i * 0.2)
        const time = (i + 1) * 0.4
        const z = i * 50
        TweenLite.to(mesh.position, time, {delay, z, ease: Power2.easeInOut})
      })
    },
    initThree () {
      this.renderer = new THREE.WebGLRenderer({ antialias: false })
      this.renderer.setClearColor(0x232323, 1)
      this.$el.append(this.renderer.domElement)
      this.scene = new THREE.Scene()
      this.setViewport(window.innerWidth, window.innerHeight)
    },

    initCamera () {
      this.camera = new THREE.OrthographicCamera(
        this.viewport.left,
        this.viewport.right,
        this.viewport.top,
        this.viewport.bottom,
        this.viewport.near,
        this.viewport.far
      )
      this.camera.position.z = 200
      this.scene.add(this.camera)
    },

    initFloor () {
      this.textureLoader = new THREE.TextureLoader()
      this.object3d = new THREE.Object3D()
      for (let index = 1; index < 10; index++) {
        const texture = this.textureLoader.load(`/img/backgrounds/plan/plan-${index}.png`, () => { this.forceUpdate = true })
        texture.minFilter = THREE.LinearFilter
        texture.magFilter = THREE.LinearFilter
        const mat = new THREE.MeshBasicMaterial({
          map: texture,
          transparent: true
        })
        const plane = new THREE.PlaneGeometry(1, 1)
        const mesh = new THREE.Mesh(plane, mat)
        mesh.position.z = index
        this.object3d.add(mesh)
      }
      this.scene.add(this.object3d)
    },

    initLight () {
      const light = new THREE.AmbientLight(0xffffff) // white light
      this.scene.add(light)
    },

    resize () {
      this.w = window.innerWidth
      this.h = window.innerHeight
      this.setViewport()
      this.camera.left = this.viewport.left
      this.camera.right = this.viewport.right
      this.camera.top = this.viewport.top
      this.camera.bottom = this.viewport.bottom
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(this.w, this.h)
      const size = Math.max(this.w, this.h)
      this.object3d.scale.set(size * 1.1, size * 1.1, 1)
    },

    setViewport () {
      const viewSize = this.h
      const aspectRatio = this.w / this.h
      this.viewport = {
        viewSize: viewSize,
        aspectRatio: aspectRatio,
        left: (-aspectRatio * viewSize) / 2,
        right: (aspectRatio * viewSize) / 2,
        top: viewSize / 2,
        bottom: -viewSize / 2,
        near: -500,
        far: 1000
      }
    },

    tick () {
      const dX = this.x - this.easeX
      const dY = this.y - this.easeY
      this.easeX += dX / 20
      this.easeY += dY / 20

      if (Math.abs(dX) >= 0.01 || Math.abs(dY) >= 0.01 || this.forceUpdate) {
        this.object3d.rotation.y = ((this.easeX - this.w / 2) / this.w) / 2
        this.object3d.rotation.x = ((this.easeY - this.h / 2) / this.h) / 2
        this.renderer.render(this.scene, this.camera)

        this.forceUpdate = false
      }
    },

    mouseMoveHandler (e) {
      this.x = e.clientX
      this.y = e.clientY

      if (this.timer) {

      }
    }
  }
}
</script>

<style >
.BackgroundRelief{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
}
canvas{
  width: 100%;
  height: 100%;
}

</style>
